module.exports = __webpack_public_path__ + "static/media/12_r_hrusevka_71.56_69.44.fb2a51ee.png";